module.exports = __webpack_public_path__ + "static/img/Jeremy-McGovern.9d58163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy-McGovern.jpg
// module id = otMR
// module chunks = 0